
class ApiCalls {

    static post(url, data, success) {
	
		var result = '';

		var _data = JSON.stringify(data);

		var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");

		xhr.open('POST', url);

		xhr.onreadystatechange = function() {
			if (xhr.readyState>3 && xhr.status==200) { 
				success(xhr.response);
			}
		};

		xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		xhr.send(_data);

	}
}

export default ApiCalls 


// WEBPACK FOOTER //
// ./Scripts/App/Hosting/Classes/ApiCalls.es6